/**
 * Identification-related strings.
 */
import React from 'react';
import Icons from '../ui/IconButton/Icons';
import FontAwesomeButton from "../ui/Buttons/FontAwesomeButton";

export default {
    d_title: 'Identification',
    h_title: `<div><p>This section documents all forms of identification for the contact, including driver's license(s), military ID's, state ID cards, or any other form of identification.</p></div>`,

    d_portal_title: 'Forms of ID',
    h_portal_title: `Please list all forms of ID, such as driver's license, passport, and military ID.`,

    d_method: 'Method',
    h_method: `<div><p>What method of identification is this?</p><p>This can be anything you want, including Drivers License, Social Security Card, Military ID, Passport or State-issued IDs.</p></div>`,

    d_identifier: <div className='u-row'>
        <div>Identifier</div>
        <FontAwesomeButton icon={Icons.PRIVATE.reactIcon} iconColor='maroon'/>
    </div>,
    h_identifier: `<div><p>The unique identifier for this ID.</p></div>`,

    d_issuer: 'Issuer',
    h_issuer: `<div><p>The legal entity that issued the ID.</p><p>For example, a driver's license might be issued by the Illinois Department of Transportation, or a Passport might be issued by Canada.</p></div>`,

    d_issuedOn: 'Issued On',
    h_issuedOn: `<div><p>The date the ID was issued.</p></div>`,

    d_expiresOn: 'Expires On',
    h_expiresOn: `<div><p>The date the ID expires.</p></div>`,

    d_additionalInfo: 'Additional Information',
    h_additionalInfo: `<div><p>Any additional information that you want to add.</p></div>`,
};